"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/stores/auth";
import { fetchMe } from "@/lib/auth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const [hydrated, setHydrated] = useState(false);
  const [ready, setReady] = useState(false);

  // Step 1: wait for Zustand persist middleware to finish reading localStorage.
  useEffect(() => {
    if (useAuthStore.persist.hasHydrated()) {
      setHydrated(true);
      return;
    }
    const unsub = useAuthStore.persist.onFinishHydration(() => setHydrated(true));
    return unsub;
  }, []);

  // Step 2: once hydrated, check token and verify with backend.
  useEffect(() => {
    if (!hydrated) return;
    if (!token) {
      router.replace("/login");
      return;
    }
    fetchMe()
      .then(() => setReady(true))
      .catch(() => {
        useAuthStore.getState().clear();
        router.replace("/login");
      });
  }, [hydrated, token, router]);

  if (!ready || !user) {
    return (
      <div data-testid="auth-loading" className="app-main text-sm text-slate-500">
        Ładowanie...
      </div>
    );
  }

  return <>{children}</>;
}
